import React, { Children, useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import useFlow from "./hooks/useFlow";
import ProgressNavigation from "./components/progress-navigation/ProgressNavigation";
import ProgressNavigationItem from "./components/progress-navigation/ProgressNavigationItem";
import Header from "./components/header/Header";
import ModalRoot from "../../shared/components/ModalRoot";
import { findGetParameter, clear } from "./utils/form-utils";
import { Form } from "react-final-form";
import classNames from "classnames";

const App = () => {
    const {
        currentStep,
        currentStepComponent,
        goTo,
        steps,
        state,
        dispatch,
        submitStep,
        submitForm,
        initialValues,
        error,
        allSteps,
    } = useFlow();

    const [hasMounted, setHasMounted] = useState(false);
    if (error) {
        return (
            <div className="flow-state-error">
                <h2>Der gik noget galt..</h2>
                <h2>{error}</h2>
            </div>
        );
    }

    const underEducation = findGetParameter("UnderEducation") || undefined;
    const SkipUnionFlag =
        findGetParameter("SkipUnionFlag") ||
        findGetParameter("SkipUnion") ||
        undefined;

    const classes = classNames("member-registration", {
        "member-registration--under-education": underEducation,
    });
    //Keep this Header init comment: form={form} askForExitConsent={currentStep && currentStep.NavigationStepIndex !== null && currentStep.NavigationStepIndex > 2}
    let isAkasseIncluded = "";

    const membershipTypeSteps = allSteps.filter(
        (step) => step.step === "MembershipType"
    );
    let lastMembershipTypeStep =
        membershipTypeSteps.length > 0
            ? membershipTypeSteps[membershipTypeSteps.length - 1]
            : null;

    if (lastMembershipTypeStep) {
        isAkasseIncluded =
            lastMembershipTypeStep.formValues.formValues.MembershipType ===
            "Forbund"
                ? false
                : true;
    }

    return (
        <Form
            initialValues={initialValues}
            onSubmit={
                currentStep && currentStep.Component === "Payment"
                    ? submitForm
                    : submitStep
            }
            destroyOnUnregister={false}
            mutators={{
                clear,
                changeFieldValue(args, state, utils) {
                    utils.changeValue(
                        state,
                        args[0].fieldName,
                        () => args[0].value
                    );
                },
            }}
            render={({ values, handleSubmit, submitting, form }) => (
                <div className={classes}>
                    <Header skipUnionFlag={SkipUnionFlag}></Header>
                    <div className="member-registration--form-content">
                        {currentStep &&
                            currentStep.NavigationStepIndex !== null &&
                            currentStep.NavigationSteps && (
                                <ProgressNavigation
                                    membershipIncludesAkasse={isAkasseIncluded}
                                    title={
                                        currentStep &&
                                        currentStep.NavigationSteps &&
                                        typeof currentStep.NavigationStepIndex ===
                                            "number" &&
                                        currentStep.NavigationSteps[
                                            currentStep.NavigationStepIndex
                                        ] &&
                                        currentStep.NavigationSteps[
                                            currentStep.NavigationStepIndex
                                        ].Title
                                            ? currentStep.NavigationSteps[
                                                  currentStep
                                                      .NavigationStepIndex
                                              ].Title
                                            : "Default Title"
                                    }
                                    hideProgress={
                                        currentStep.NavigationStepIndex < 0
                                    }
                                    progress={
                                        "Trin " +
                                        (currentStep.NavigationStepIndex + 1) +
                                        " af " +
                                        currentStep.NavigationSteps.length
                                    }
                                >
                                    {currentStep.NavigationSteps.map(
                                        (step, index) => (
                                            <ProgressNavigationItem
                                                flowIndex={Number(
                                                    currentStep.NavigationStepIndex
                                                )}
                                                goTo={goTo}
                                                index={index}
                                                key={step.Title}
                                                steps={steps}
                                                title={step.Title}
                                                disabled={
                                                    step.DisabledPerDefault
                                                }
                                                values={values}
                                            />
                                        )
                                    )}
                                </ProgressNavigation>
                            )}
                        <form
                            className="flow-forms"
                            noValidate
                            onSubmit={handleSubmit}
                            id="main"
                        >
                            <AnimatePresence
                                initial={false}
                                mode="wait" // ensures exit animation completes before new component enters
                                onExitComplete={() => {
                                    if (!hasMounted) {
                                        setHasMounted(true);
                                    }
                                    dispatch({ type: "STEP_CHANGE_ENDED" });
                                }}
                                custom={state.isAnimDirectionForward}
                            >
                                {currentStepComponent && (
                                    <motion.div
                                        key={currentStep?.Component}
                                        custom={state.isAnimDirectionForward}
                                        variants={{
                                            initial: (forward) => ({
                                                opacity: 0,
                                                x: forward ? 50 : -50,
                                            }),
                                            animate: { opacity: 1, x: 0 },
                                            exit: (forward) => ({
                                                opacity: 0,
                                                x: forward ? -50 : 50,
                                            }),
                                        }}
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        transition={{ duration: 0.3 }}
                                    >
                                        {currentStepComponent}
                                    </motion.div>
                                )}
                            </AnimatePresence>

                            {/* {window.SHOW_DEBUG_INFO && (
                                <pre className="test-form-info">
                                    {JSON.stringify(values, null, 2)}
                                </pre>
                            )} */}
                        </form>
                    </div>
                    <ModalRoot />
                </div>
            )}
        />
    );
};

export default App;
